import React, {ReactElement} from 'react';
import {useUIStore} from 'store/UI';
import {DisplayValue} from 'components/DisplayValue';

export const Display = (): ReactElement => {
  const {settingsVisible} = useUIStore();
  return !settingsVisible && <DisplayValue />;
};
